<template>
  <div
    class="field field--select"
    :style="{ '--form-item-width': grid.Cols, '--form-item-height': grid.Rows, '--form-item-start': grid.Offset }"
  >
    <span class="field__label">
      <label :for="id">
        <slot name="label"></slot>
        <font-awesome-icon v-if="description" icon="info-circle" class="info-icon" v-description="description" />
      </label>
      <slot></slot>
    </span>
    <div v-if="readonly" class="ui fluid search selection dropdown disabled">
      <i class="dropdown icon"></i>
      <input autocomplete="off" tabindex="-1" name="" class="search" />
      <div data-vss-custom-attr="" class="text">{{ readonlyValue }}</div>
    </div>
    <ModelListSelect
      v-else
      ref="select"
      :list="selectOptions"
      :value="JSON.stringify(forcevalue != null && forcevalue != false ? forcevalue : value)"
      :isDisabled="readonly"
      option-value="code"
      option-text="name"
      :filterPredicate="nativeSearch ? nativeSearchPredicate : v => v"
      @searchchange="onSearch($event)"
      @input="onUpdate($event)"
      @keydown.native.enter.prevent="onEnter"
      @keydown.native.arrow-down="forceShowList = true"
      :class="{ 'hidden-list': hideList }"
    />
    <small v-if="error" style="color: red; font-style: italic; margin-left: 5px;">{{ error }}</small>
  </div>
</template>

<script>
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelListSelect } from 'vue-search-select'
export default {
  name: 'field-select',
  props: {
    error: String,
    grid: Object,
    id: String,
    name: String,
    description: String,
    options: Array,
    readonly: Boolean,
    required: Boolean,
    allowSkipWhenEmpty: Boolean,
    value: [String, Boolean, Number],
    forcevalue: [String, Boolean, Number],
    searching: Boolean,
    listOnSearch: Boolean,
    nativeSearch: Boolean
  },
  data() {
    return {
      searchValue: '',
      forceShowList: false
    }
  },
  computed: {
    hideList() {
      if (this.forceShowList) return false
      return this.listOnSearch && !this.searchValue
    },
    readonlyValue() {
      // eslint-disable-next-line eqeqeq
      const v = JSON.stringify(this.forcevalue != null && this.forcevalue != false ? this.forcevalue : this.value)

      const foundValue = this.selectOptions.find(opt => {
        return opt.code === v
      })

      return typeof foundValue !== 'undefined' ? foundValue.name : ''
    },
    selectOptions() {
      return this.options.map(opt => ({
        code: JSON.stringify(opt.Value),
        name: opt.Title
      }))
    }
  },
  methods: {
    reset() {
      this.item = {}
    },
    onUpdate(newValue) {
      if (!newValue) return
      this.$emit('input', JSON.parse(newValue))
      this.$emit('search', '')
      // this.$emit('nextInput')
    },
    onSearch(search) {
      this.searchValue = search
      this.$emit('search', search)
    },
    onBlur() {
      this.forceShowList = false
    },
    onEnter(e) {
      let hasOneOption = false
      let hasValue = false
      if (this.nativeSearch) {
        hasOneOption = this.$refs?.select?.$children?.[0]?.filteredOptions.length === 1
      } else {
        hasOneOption = this.options.length === 1
        hasValue = !(this.value === null || this.value === '')
      }

      // Set the selected item, if any
      let selected = this.$refs?.select?.$el?.querySelector('.menu .item.selected:not(:hover)')
      if (!selected && hasOneOption && !hasValue) {
        selected = this.$refs?.select?.$el?.querySelector('.menu .item:first-child')
      }

      // If no item was selected, and we already have a value AND search term is empty, move to the next input
      if (!selected && this.value && !this.searchValue) {
        this.$emit('nextInput')
        return
      }

      // If we have a selected item, click it to select it and then move to the next input
      if (selected) {
        selected.click()
        this.$emit('nextInput')
        return
      }

      // Allow empty value if the field explicitly allows it
      if (this.allowSkipWhenEmpty && !this.searchValue && (this.value === null || this.value === '')) {
        this.$emit('nextInput')
      }
    },
    emitFirstOption() {
      if (!this.searchValue) return
      if (!this.options || this.options.length === 0) return
      this.$emit('input', this.options[0].Value)
    },
    nativeSearchPredicate(label, search) {
      // If search term is number, match only from start of string
      if (!isNaN(search)) {
        return label.toLowerCase().startsWith(search.toLowerCase())
      }

      // Otherwise, match anywhere in the string (Should be the same as default behaviour, without the use of regex)
      return label.toLowerCase().includes(search.toLowerCase())
    }
  },
  watch: {
    value() {
      if (!this.value) this.searchValue = ''
    }
  },
  mounted() {
    // get the dropdown icon 'dropdown icon' from refs.select
    const select = this.$refs.select
    const el = select?.$el
    if (!el) return
    const dropdownIcon = el.querySelector('.dropdown.icon')
    if (dropdownIcon) {
      // add a click event listener to the dropdown icon
      dropdownIcon.addEventListener('click', () => {
        this.forceShowList = true
      })
    }

    // Fix blur not propagating properly
    const input = el.querySelector('input')
    if (input) {
      input.addEventListener('blur', () => {
        this.onBlur()
        this.$emit('blur')
      })
    }

    // Watch for menu updates and unset the pointer
    // This is needed because we want to control what happens when the user presses enter
    const menu = el.querySelector('.menu')
    if (menu) {
      const observer = new MutationObserver(() => {
        if (!select.$children?.[0]) return
        select.$children[0].pointerSet = () => {} // Prevents 'mouseoverevent' from setting the pointer...
        select.$children[0].pointer = this.options.length === 1 ? 0 : -1
      })
      observer.observe(menu, {
        childList: true
      })
    }
  },
  components: {
    ModelListSelect
  }
}
</script>

<style scoped>
/* .field >>> .ui.selection.dropdown .menu > .item {
  font-family: monospace;
} */

.field >>> .ui.dropdown .menu .selected.item,
.field >>> .ui.dropdown.selected {
  background: rgba(0, 0, 0, 0.08);
}

.hidden-list >>> .menu {
  display: none !important;
}
</style>
